import { css } from "@compiled/react";

import { DataEventProps } from "@/libraries/wpl/foundations/src";

export interface TemplatesTabCardContentProps {
    iconAlt: string;
    iconSrc: string;
    upperText: string;
    cardTitle: string;
    text: string;
    href: string;
}

export interface TemplatesTabCardImageProps {
    imageIconAlt: string;
    imageIconSrc: string;
}

const cardContainerStyles = css({
    margin: "16px",
    flex: "1 1 0px"
});

const innerCardStyles = css({
    "padding": "25px 25px 0",
    "display": "flex",
    "flexDirection": "column",
    "backgroundColor": "#fff",
    "borderRadius": "8px",
    "boxShadow": "1px 1px 6px 0 rgba(0, 0, 0, 0.2)",
    "height": "100%",
    "transition": "box-shadow 0.5s ease-in-out",
    "a:hover": {
        boxShadow: "2px 5px 25px -4px rgba(0, 0, 0, 0.35)"
    }
});

const imgContainerStyles = css({
    position: "absolute"
});

const imageStyles = css({
    verticalAlign: "bottom",
    maxWidth: "80px",
    maxHeight: "80px, 90%"
});

const upperTextStyles = css({
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    paddingInlineStart: "80px",
    minHeight: "76px",
    color: "#56667e",
    lineHeight: "16px",
    margin: "0 0 24px"
});

const cardTitleStyles = css({
    fontSize: "24px",
    marginBlockEnd: "5px",
    fontWeight: "500",
    marginBlockStart: "0",
    lineHeight: "28.8px",
    color: "#091e42",
    minHeight: "50px"
});

const textStyles = css({
    fontWeight: "400",
    lineHeight: "20px",
    color: "#091e42",
    margin: "0 0 24px"
});

export const TemplatesTabCardImage = ({
    imageIconAlt,
    imageIconSrc
}: TemplatesTabCardImageProps) => {
    return (
        <div css={imgContainerStyles}>
            <img alt={imageIconAlt} src={imageIconSrc} css={imageStyles} />
        </div>
    );
};

const TemplatesTabCardContent = ({
    iconAlt,
    iconSrc,
    upperText,
    cardTitle,
    text,
    href
}: TemplatesTabCardContentProps) => {
    const templatesTabCardDataEventProps: DataEventProps = {
        "data-product-key": "confluence",
        "data-event-component": "linkButton",
        "data-event-container": "templatesTabCard",
        "data-event": "clicked",
        "data-track-event": "templatesTabCard.linkButton"
    };
    const imageProps: TemplatesTabCardImageProps = {
        imageIconAlt: iconAlt,
        imageIconSrc: iconSrc
    };

    return (
        <div css={cardContainerStyles}>
            <a
                href={href}
                css={innerCardStyles}
                {...templatesTabCardDataEventProps}
            >
                <TemplatesTabCardImage {...imageProps} />
                <p css={upperTextStyles}>{upperText}</p>
                <h4 css={cardTitleStyles}>{cardTitle}</h4>
                <p css={textStyles}>{text}</p>
            </a>
        </div>
    );
};

export default TemplatesTabCardContent;
